import { createBrowserRouter, Navigate, type RouteObject } from 'react-router';
import { captureLaunchToken } from '@/auth/session-token';

// Bootstrap: capture any session/QA token handed in via the LTI 302 (or QA preview link)
// query string before the router renders, so the first API call carries the bearer token.
captureLaunchToken();

// ONE dynamic delivery route (no per-course pages, §4) at `/` — the learner lands here after the
// LTI 302. `/health` keeps the skeleton health page for deploy smoke checks.
const routes: RouteObject[] = [
  {
    path: '/',
    lazy: async () => {
      const { Delivery } = await import('@/modules/delivery/delivery');
      return { Component: Delivery };
    },
  },
  {
    path: '/health',
    lazy: async () => {
      const { Health } = await import('@/modules/health/health');
      return { Component: Health };
    },
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
];

export const router = createBrowserRouter(routes);
